import { DataLayer } from '@grandvisionhq/analytics';

const pushChangeSolutionVolumeEvent = (eventLabel)=>{
    DataLayer.pushEvent({
        event: 'click_solution_pdp',
        eventAction: 'select solutions volume',
        eventLabel
    });
};

export { pushChangeSolutionVolumeEvent };
//# sourceMappingURL=change-solution-volume.js.map
